export * from  './areas.resolver'


// WEBPACK FOOTER //
// /app/src/shared/resolvers/index.ts